module.exports = __webpack_public_path__ + "img/logo-roumu-set.e7c295e5.svg";